import UsersList from '../models/user/UsersList'
const usersRouter = {

  path: '/users',
  name: "UsersList",
  component: UsersList,
  props: true,
  meta: {
    requiresAuth: true,
  },
// params: {id: item.productId}}
};

export default usersRouter;